export default {
  name: 'chat',
  path: 'chat',
  component: () => import(/* webpackChunkName: "chat" */ './index.vue')
}
